import { defineComponent as _defineComponent } from 'vue'
import config from "@/config";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

/**
 * @name: 底部
 * @author: lili
 * @date: 2023-03-24 15:05
 * @description：底部
 * @update: 2023-03-24 15:05
 */

return { __sfc: true,config }
}

})